// extracted by mini-css-extract-plugin
export default {"paymentMethodTable":"zEyUa65XWyb_hFnIU6S0"};